export default "__VITE_ASSET__B$LBNtsY__"